angular.module('unica_media_directory.media_directory_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// media_directory
		.state('app.media_directory', {
			url: '/media-directory',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/media-directory/templates/media-directory.html',
					controller: 'MediaDirectoryBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

		// media_directory LIST AND DELETE
		.state('app.media_directory.list', {
			url: '/list/:event_id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/list.html',
					controller: 'MediaDirectoryListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Lista Directory',
				parent: function($scope) {
					return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
				}
			}
		})

		// media_directory CREATE
		.state('app.media_directory.create', {
			url: '/create/:event_id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/create.html',
					controller: 'MediaDirectoryCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Directory',
				parent: 'app.media_directory.list'
			}
		})

		// media_directory EDIT
		.state('app.media_directory.edit', {
			url: '/edit/:event_id/:id',
			views: {
				'mediaDirectoryContent': {
					templateUrl: './modules/media-directory/templates/edit.html',
					controller: 'MediaDirectoryEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Directory',
				parent: 'app.media_directory.list'
			}
		});

});

